import { render, staticRenderFns } from "./LinhaResumoAlertas.vue?vue&type=template&id=50e629ae&lang=pug"
import script from "./LinhaResumoAlertas.vue?vue&type=script&lang=js"
export * from "./LinhaResumoAlertas.vue?vue&type=script&lang=js"
import style0 from "./LinhaResumoAlertas.vue?vue&type=style&index=0&id=50e629ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports